import { render } from "./KeFu.vue?vue&type=template&id=78bf9dd6&scoped=true"
import script from "./KeFu.vue?vue&type=script&lang=js"
export * from "./KeFu.vue?vue&type=script&lang=js"

import "./KeFu.vue?vue&type=style&index=0&id=78bf9dd6&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bf9dd6"]])

export default __exports__